import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Delivery() {
  return (
    <div className="delivery">
      <Header />

      <main>
        <div className="grid grid-cols-1 overflow-x-hidden ">
          <div>
            <div className="md:px-8 lg:px-12   ">
              <div className="pt-6">
                <div className="">
                  <div
                    __typename="ComponentComponentsText"
                    container="[object Object]"
                    id={5637}
                  >
                    <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                      <h1>Delivery Information</h1>
                      <table>
                        <thead>
                          <tr>
                            <th>Delivery option</th>
                            <th>Delivery times</th>
                            <th>Delivery cost</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>UK Standard Delivery</td>
                            <td>5-7 working days</td>
                            <td>£3.99 per order</td>
                            <td>
                              <strong>
                                ⭐{" "}
                                <Link
                                  onClick={toTop}
                                  title="Boventraix PREMIER Delivery"
                                  to="/shipping"
                                >
                                  FREE with Boventraix PREMIER
                                </Link>
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>UK Next Day Delivery</td>
                            <td>
                              Subject to cut-off times. See below for details
                            </td>
                            <td>£5.99 per order</td>
                            <td>
                              <strong>
                                ⭐{" "}
                                <Link
                                  onClick={toTop}
                                  title="Boventraix PREMIER Delivery"
                                  to="/shipping"
                                >
                                  FREE with Boventraix PREMIER
                                </Link>
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>UK Express Delivery </td>
                            <td>Delivered Within 3 Working Days</td>
                            <td>£4.99 per order</td>
                            <td>
                              <strong>
                                ⭐{" "}
                                <Link
                                  onClick={toTop}
                                  title="Boventraix PREMIER Delivery"
                                  to="/shipping"
                                >
                                  FREE with Boventraix PREMIER
                                </Link>
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Premium DPD Next Day Delivery</td>
                            <td>
                              Order before 9pm Sun-Friday and before 8pm Sat
                            </td>
                            <td>£6.99 per order</td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              24/7 InPost Locker - <strong>*NEW*</strong>
                            </td>
                            <td>Up to 6 working days*</td>
                            <td>£2.49 per order</td>
                          </tr>
                          <tr>
                            <td> Evri Parcel Shop - Next Day Delivery</td>
                            <td>
                              Up to 3 working days. Order before Midnight, 7
                              days a week
                            </td>
                            <td>£5.99 per order</td>
                          </tr>
                          <tr>
                            <td> Evri Parcel Shop</td>
                            <td>
                              5 - 8 working days* (Monday – Saturday delivery){" "}
                            </td>
                            <td>£3.99 per order</td>
                          </tr>
                          <tr></tr>
                          <tr>
                            <td>Northern Ireland Standard Delivery</td>
                            <td>5-7 working days</td>
                            <td>£4.99 per order</td>
                            <td>
                              <strong>
                                ⭐{" "}
                                <Link
                                  onClick={toTop}
                                  title="Boventraix PREMIER Deliver"
                                  to="/shipping"
                                >
                                  FREE with Boventraix PREMIER
                                </Link>
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Bulky Item Delivery</td>
                            <td>5-7 working days</td>
                            <td>£4.99 per order</td>
                          </tr>
                        </tbody>
                      </table>
                      <h4>
                        Next Day Delivery is subject to placing your order
                        before specific cut-off times:
                      </h4>
                      <ul>
                        <li>
                          <div>
                            <p className="mx-auto px-6" node="[object Object]">
                              Boventraix &amp; Boventraix Wallis, Oasis, Dorothy
                              Perkins, Warehouse, Principles &amp; Nasty Gal
                              Beauty, Misspap, Burton, Coast - Order by 12am for
                              Next Day Delivery, 7 days a week.
                            </p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <p className="mx-auto px-6" node="[object Object]">
                              Beauty &amp; Karren Millen - Order by 8pm for Next
                              Day Delivery, 7 days a week.
                            </p>
                          </div>
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Next Day Delivery excludes all Concessionaire Brands.
                          Click{" "}
                          <Link onClick={toTop} to="/">
                            here
                          </Link>{" "}
                          for full list. Please be advised that these cut off
                          dates will differ for Concessionaire Brands.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Some items will be subject to a bulky item delivery
                          charge of £4.99. This fee covers the additional costs
                          associated with servicing orders containing such items
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Contact Us{" "}
                          <Link onClick={toTop} to="/contact">
                            here
                          </Link>{" "}
                          for any query concerning your order.
                        </p>
                      </div>
                      <h4>InPost Locker</h4>
                      <ul>
                        <li>
                          *Postcodes with an additional ‘up to 2 day’ delivery
                          are: AB, DD, DG, EH, FK, G, KA1-24, KA29-30, IV1-40,
                          KY, KW1-14, ML, TR21-25, PO30+, PA20–39, PH4–40 &amp;
                          TD
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="md:px-8 lg:px-12   ">
              <div className="pt-6">
                <div className="">
                  <div
                    __typename="ComponentComponentsText"
                    container="[object Object]"
                    id={5638}
                  >
                    <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                      <h2>Frequently Asked Questions?</h2>
                      <h3>Where is my order?</h3>

                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you have received your dispatch email then this
                          means that your order is on the way, simply enter the
                          order number above and hit find order to track your
                          order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you have not yet received your dispatch email or
                          don't know your order number then please contact us{" "}
                          <Link onClick={toTop} to="/contact">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <h4>Northern Ireland</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Some deliveries to Northern Ireland will be shipped
                          via the Republic of Ireland, this is nothing to worry
                          about and happens due to the ferry connection that our
                          carrier uses.
                        </p>
                      </div>
                      <h3>Why is my order late?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Most of our deliveries can take place between 8am to
                          9pm. If its after 9pm on your expected delivery date
                          then your order is late. On rare occasions deliveries
                          can be delayed due to events out of our control, when
                          this happens we work with our couriers to get your
                          order moving a quickly as possible. Most delayed
                          deliveries are delivered on the following day.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If your delivery date has passed and you would like us
                          to investigate this further, please contact us{" "}
                          <Link onClick={toTop} to="/contact">
                            here
                          </Link>{" "}
                          and have your order number ready.
                        </p>
                      </div>
                      <h3>Can I cancel or edit my order?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          As soon as you place your order, we’re on it – we know
                          you need it fast! Unfortunately this means we will be
                          unable to make any changes as it’s already being
                          processed at the warehouse (literally within
                          seconds!). You’ll need to place another order or
                          return any unwanted items.
                        </p>
                      </div>
                      <h3>Missing item(s) from my order</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Sorry an items missing, we’ve either packed it wrong,
                          it’s coming in more than one parcel or it’s fallen off
                          the back of the wagon. If your expected delivery date
                          has passed, then please contact us{" "}
                          <Link onClick={toTop} to="/contact">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <h3>
                        My tracking is showing that my parcel is being returned
                        to sender
                      </h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The carrier has been unable to deliver your parcel to
                          you (you may not have been in or they might not have
                          been able to gain access to your property). If your
                          tracking is showing as being returned to us, you can
                          wait for your parcel to come back and we will give you
                          a refund when it does. A typical refund will take up
                          to 21 days, that’s 14 days for the parcel to arrive
                          back at our warehouse and us processing with up to 7
                          days for it to make its way through the banking
                          system.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If the carrier was unable to deliver this time it may
                          be worth checking out the carriers app, many of our
                          carrier will allow you to add instructions for the
                          driver or a preferred safe place / neighbour for your
                          parcel to be left with if you're not in. We also have
                          other delivery options such as click &amp; collect and
                          locker collection which may be more suitable for
                          future deliveries.
                        </p>
                      </div>
                      <h3>I received a faulty item, what do I do?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We’re really sorry to hear that you’ve received an
                          item that’s not in perfect condition. So that we can
                          get this fixed for you please head over to our section
                          within 30 days of receiving your order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          To help us get this fixed for you ASAP, when you first
                          contact us please include the following information;
                        </p>
                      </div>
                      <ul>
                        <li>Your name</li>
                        <li>Order number</li>
                        <li>Product name and code</li>
                        <li>Picture of the fault</li>
                        <li>Description of the fault</li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (The product name and code can be found on your order
                          confirmation email).
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you contact us via email please have an image of
                          the faulty item ready for when you receive a reply as
                          you won’t be able to attach the image on the form just
                          yet.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please note, we cannot offer refunds on cosmetics,
                          pierced jewellery and fashion facemasks or on swimwear
                          and lingerie if the hygiene seal is not in place or
                          has been broken
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          This does not affect your statutory rights.
                        </p>
                      </div>
                      <h3>I received an incorrect item, what do I do?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will get this fixed for you ASAP just head over to
                          our{" "}
                          <Link onClick={toTop} to="/contact">
                            Contact Us
                          </Link>{" "}
                          page.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          When you message, please include the following
                          information:
                        </p>
                      </div>
                      <ul>
                        <li>Your name</li>
                        <li>Order number</li>
                        <li>Product name and code of the item ordered</li>
                        <li>Product name and code of the item received</li>
                        <li>
                          Picture of the incorrect item and a description of the
                          incorrect item received
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You won’t be able to attach an image of the incorrect
                          item just yet but make sure you have one ready for
                          when you receive a reply from us. Please wait until
                          you’ve spoken to our Customer Care team before you
                          return anything to us so we can make sure we get the
                          correct item to you as quickly as possible.
                        </p>
                      </div>
                      <h3>
                        My parcel is in the Republic of Ireland but I live in
                        Northern Ireland?
                      </h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Some deliveries to Northern Ireland will be shipped
                          via the Republic of Ireland, this is nothing to worry
                          about and happens due to the ferry connection that our
                          carrier uses.
                        </p>
                      </div>
                      <h3>How to Collect with Evri</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          When you select a Evri ParcelShop or Locker delivery
                          we will let you know when your parcel arrives at your
                          selected location. For ParcelShop collections, simply
                          take along your ID to collect and for Lockers you will
                          be sent a QR code which can be scanned to open the
                          locker door.
                        </p>
                      </div>
                      <h3>How long do I have to pick up my parcel?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You will have 10 days to collect from a ParcelShop, we
                          will send you a little reminder on days 3, 6 and a
                          final reminder when you have 24 hours left to collect.
                          Lockers, you’ve got up to 3 days, reminder will be
                          sent when you have 24 hours left to collect.
                        </p>
                      </div>
                      <h3>How do I track my parcel?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          There are loads of easy ways to track your parcel, You
                          can find these in the Evri app, in the email
                          confirmation from Evri or on the Evri website -
                          https://www.evri.com/track-a-parcel
                        </p>
                      </div>
                      <h3>When can I collect my parcel?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Evri will send you an email the moment your parcel
                          arrives. If you’ve got the app, you’ll also get a
                          notification from them. Shops are open early until
                          late and lockers are 24/7 so you can pick up whenever
                          it works for you.
                        </p>
                      </div>
                      <h3>Can someone else pick up your parcel?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Yes they can - just ask them to take their ID along to
                          the ParcelShop and say they are collecting a parcel on
                          your behalf, for lockers just send them a screenshot
                          of your QR code.
                        </p>
                      </div>
                      <h3>Do you need an ID to collect your parcel?</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Yes you do, we need to ensure that the right person is
                          picking up your parcel. A valid photo ID helps us
                          confirm identity and prevents parcels from being
                          handed over to the wrong individual. Acceptable forms
                          include a debit or credit card, passport, UK driving
                          licence, Photo ID , Birth Certificate, Foreign ID or a
                          utility bill.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Delivery;
